<div class="performance-monitor ui__panel ui__panel--floating">
            
    
</div>